import styled from 'styled-components';

/* Main Vlogs Section */
export const VlogSection = styled.section`
  text-align: center;
  background: #222; /* dark portfolio background */
  color: #f4f4f4;
  padding: 40px 20px;

  h1, h3 {
    margin-bottom: 20px;
  }

  .Container {
    display: flex;
    gap: 20px;
    margin: 0 auto;
    max-width: 1100px;
    flex-wrap: wrap;
  }

  .vlogdivleft {
    flex: 2;
    padding: 10px;
  }

  .vlogdivright {
    flex: 1;
    padding: 10px;
    max-height: 500px;
    overflow-y: auto;
    box-shadow: 2px 2px 15px rgba(0,0,0,0.3);
  }

  /* Scrollbar styling */
  .vlogdivright::-webkit-scrollbar {
    width: 8px;
  }
  .vlogdivright::-webkit-scrollbar-track {
    background: #222;
  }
  .vlogdivright::-webkit-scrollbar-thumb {
    background-color: #0ff; /* cyan scrollbar */
    border-radius: 4px;
  }

  @media (max-width: 768px) {
    .Container {
      flex-direction: column;
    }

    .vlogdivright {
      max-height: none;
    }
  }
`;

/* Main Video Wrapper */
export const VideoWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto 30px auto;

  iframe {
    width: 100%;
    height: 400px;
    border: none;
    border-radius: 8px;
  }

  @media (max-width: 480px) {
    iframe {
      height: 220px;
    }
  }
`;

/* Thumbnails Gallery — scrollable horizontal */
export const Gallery = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 15px;
  padding: 10px 0;
  scroll-behavior: smooth;
  
  /* Hide vertical scrollbar if any */
  overflow-y: hidden;

  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #0ff;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track {
    background: #222;
  }
`;

/* Individual Thumbnail — maintain flex spacing */
export const Thumbnail = styled.img`
  flex: 0 0 auto; /* prevents shrinking */
  width: 150px;
  height: auto;
  border-radius: 5px;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 0 5px rgba(0,0,0,0.2);

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 0 15px #0ff;
    border: 2px solid #0ff;
  }

  @media (max-width: 480px) {
    width: 100px;
  }
`;

